function TimerIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M30.5 14.5C31.0523 14.5 31.5 14.9477 31.5 15.5C31.5 23.5081 25.0081 30 17 30C8.99187 30 2.5 23.5081 2.5 15.5C2.5 7.49187 8.99187 0.999999 17 0.999999C17.5523 0.999999 18 1.44771 18 2C18 2.55228 17.5523 3 17 3C10.0964 3 4.5 8.59644 4.5 15.5C4.5 22.4036 10.0964 28 17 28C23.9036 28 29.5 22.4036 29.5 15.5C29.5 14.9477 29.9477 14.5 30.5 14.5Z'
        />
        <path d='M21 14.634C21.6667 15.0189 21.6667 15.9811 21 16.366L15.75 19.3971C15.0833 19.782 14.25 19.3009 14.25 18.5311L14.25 12.4689C14.25 11.6991 15.0833 11.218 15.75 11.6029L21 14.634Z' />
      </svg>
    </span>
  );
}

export default TimerIcon;
